import { ClientObject, PropertyInit } from '../common/clientObject';
import { RequestType, ValueType } from '../comObject';
import { Recipient } from './recipient';

export class Recipients extends ClientObject implements PropertyInit {
    private properties = this.clientObjectInitPropsInfo({
        count: { propertyName: 'count', name: 'Count' },
    });

    public getPropertyInitializers(): Map<keyof Recipients, () => void> {
        return new Map<keyof Recipients, () => void>(
            Object.values(this.properties).map(({ propertyName, name }) => [
                propertyName,
                (): void =>
                    this.reference.request({
                        type: RequestType.GetProperty,
                        cacheName: propertyName,
                        name,
                    }),
            ]),
        );
    }

    public get count(): number {
        return this.reference.getValue<number>(this.properties.count.propertyName).value;
    }

    public getItem(index: number): Recipient {
        return this.reference.requestObject({
            type: RequestType.GetProperty,
            creator: Recipient,
            name: 'Item',
            args: [{ value: index, type: ValueType.Integer }],
        }).value;
    }
}
